// Which organisation the Designs page works in. The installation owner belongs to none,
// so theirs comes from the top-bar switcher; everybody else has their own.

export interface DesignOrgInput {
  /** The open design's organisation, when one is open. */
  design?: string
  /** The owner's choice in the top bar; '' for none. */
  chosen?: string
  /** The organisations the owner may choose between. */
  organisations?: readonly { id: string; active?: boolean }[]
  /** The person's own organisation; '' for the owner. */
  own: string
}

/** The organisation's id, or '' when none is known yet. */
export function designOrganisation(o: DesignOrgInput): string {
  if (o.design) return o.design
  if (o.chosen) return o.chosen
  if (o.own) return o.own
  // With exactly one, the server takes it too.
  const active = (o.organisations ?? []).filter((x) => x.active !== false)
  return active.length === 1 ? active[0]!.id : ''
}

/** That organisation's branches; the owner is answered every organisation's. */
export function branchesOf<B extends { tenantId?: string }>(branches: readonly B[], organisation: string): B[] {
  return organisation ? branches.filter((b) => !b.tenantId || b.tenantId === organisation) : [...branches]
}
